import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import { getRolePermissions } from 'src/services/authService';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';
import '../common/Report.css';
import { VarianceReportTableRef } from './VarianceReportTable';
import GetAppIcon from '@mui/icons-material/GetApp';
import VarianceReportTable from './VarianceReportTable';

const VarianceReport = () => {
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState([]);
  const varianceReportTableRef = useRef<VarianceReportTableRef>(null);

  const getPermissions = (mail) => {
    getRolePermissions(mail).then((res) => {
      const tabs = validateMultiRolesAndPermissions(res);
      const arr = tabs.filter((fil) => fil.name === 'Variance Report'); 
      setPermissions(arr[0].permissions);
    });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (Object.keys(user).length === 0) {
      navigate('/');
    } else {
      getPermissions(user.Email);
    }
  }, [navigate]);

  const handleDownload = () => {
    if (varianceReportTableRef.current) {
      varianceReportTableRef.current.handleDownload();
    }
  };

  return (
    <>
      <Helmet>
        <title>Variance Report</title>
      </Helmet>
      <Container maxWidth="xl" className='task-management-container'>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <div>
              <iframe
                title="frame"
                id="my_iframe"
                style={{ display: 'none' }}
              ></iframe>
              <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
                <Grid item display='flex'>
                  <Typography
                    style={{
                      marginLeft: '0px',
                      fontWeight: '700',
                      fontSize: '16px',
                      fontFamily:
                        'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                    }}
                  >
                    Timesheet / 
                  </Typography>
                  <Typography variant="subtitle2" className='sub-title'> Reports / Variance Report</Typography>
                </Grid>
                <Grid item>
                  <Button
                    sx={{
                      mr: 1,
                      mt: { xs: 2, md: 0 },
                      fontSize: '11px',
                      fontWeight: 'normal'
                    }}
                    variant="contained"
                    id="btn-handleClickOpen"
                    startIcon={<GetAppIcon fontSize="small" />}
                    onClick={handleDownload}
                    style={{ height: '1.75rem' }}
                    disabled={!permissions.some((perm) => perm.name === 'Download Variance Report' && perm.value === true)}  //that should be  change the the permission name  and this for test purpose
                  >
                    Download Variance Report
                  </Button>
                </Grid>
              </Grid>
            </div>
            <VarianceReportTable
              ref={varianceReportTableRef}
              permissions={permissions}
            />
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </>
  );
}

export default VarianceReport;